"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _index = require("./config/index");

var _getRoutineList = _interopRequireDefault(require("./utils/getRoutineList"));

var _index2 = require("./utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var TimeRoutineSelector =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TimeRoutineSelector, _PureComponent);

  /**
   * 属性说明
   * @alias TimeRoutineSelectorProps
   * @description 时间规律(按周)选择组件
   * @property {titleline} 默认支持参数
   * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
   * @property {titleline} 基础属性
   * @property {string} value='' 时间（二进制）
   * @property {func} onChange 已选时间的二进制字符串变更回调<br />onChange = (value, valueLabel)
   * @property {bool} [disabled=false] 是否禁用
   * @property {object} [locale={}] 替换文案
   * @example
   * locale = {
          Monday: '星期一',
          Tuesday: '星期二',
          Wednesday: '星期三',
          Thursday: '星期四',
          Friday: '星期五',
          Saturday: '星期六',
          Sunday: '星期日',
          week: '星期',
          time: '时间',
          unselected: '未选',
          selected: '已选',
          operationTip: '可拖动鼠标选择时间段',
          empty: '清空',
      };
   */

  /**
   * @private
   */
  function TimeRoutineSelector(props) {
    var _this;

    _classCallCheck(this, TimeRoutineSelector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimeRoutineSelector).call(this, props));
    _this.isMouseDown = false;
    _this.startId = null;
    _this.endId = null;
    _this.targetStatus = _index.SELECT_STATUS.SELECTED;
    _this.originRoutineList = {};
    _this.state = {
      routineList: _this.getRoutineList(props),
      curTip: '',
      tipPos: {
        top: 0,
        left: 0
      }
    };
    _this.hanldeMouseDown = _this.hanldeMouseDown.bind(_assertThisInitialized(_this));
    _this.hanldeMouseMove = _this.hanldeMouseMove.bind(_assertThisInitialized(_this));
    _this.hanldeMouseUp = _this.hanldeMouseUp.bind(_assertThisInitialized(_this));
    _this.hanldeMouseOver = _this.hanldeMouseOver.bind(_assertThisInitialized(_this));
    _this.hanldeMouseLeave = _this.hanldeMouseLeave.bind(_assertThisInitialized(_this));
    _this.updateSelection = _this.updateSelection.bind(_assertThisInitialized(_this));
    _this.endSelection = _this.endSelection.bind(_assertThisInitialized(_this));
    _this.updateSelectedTimeAndDigit = _this.updateSelectedTimeAndDigit.bind(_assertThisInitialized(_this));
    _this.updateTip = _this.updateTip.bind(_assertThisInitialized(_this));
    _this.clearSelect = _this.clearSelect.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * 调用渲染函数，并更新初始选中的时间和二进制字符串
   * @private
   */


  _createClass(TimeRoutineSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // 渲染初始化后的选中时间和二进制
      this.updateSelectedTimeAndDigit(true);

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (typeof nextProps.value !== 'undefined') {
        this.setState({
          routineList: this.getRoutineList(nextProps)
        });
      }
    }
  }, {
    key: "getRoutineList",
    value: function getRoutineList() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var result = (0, _getRoutineList["default"])(props.value);
      this.routineKeys = result.routineKeys;
      return result.routineList;
    }
    /**
     * 点下鼠标，开始选择动作，必须在选区内部开始
     * @param {object} event - 事件event对象
     * @return {void}
     * @private
     */

  }, {
    key: "hanldeMouseDown",
    value: function hanldeMouseDown(event) {
      var curId = event.target && event.target.getAttribute('data-id');
      var routineList = this.state.routineList;
      var disabled = this.props.disabled;

      if (curId && !disabled) {
        this.originRoutineList = (0, _spauiUtils.objectAssign)({}, routineList);
        this.isMouseDown = true;
        this.startId = curId;
        this.endId = curId;
        this.targetStatus = _index.SELECT_STATUS.SELECTED - this.originRoutineList[curId];
      }
    }
    /**
     * 鼠标移动，因移动过程中多次渲染，我们只拿mouseDown时的初始克隆的state做渲染运算
     * @param {object} event - 事件event对象
     * @return {void}
     * @private
     */

  }, {
    key: "hanldeMouseMove",
    value: function hanldeMouseMove(event) {
      var disabled = this.props.disabled;

      if (this.isMouseDown === true && !disabled) {
        var curId = event.target && event.target.getAttribute('data-id');

        if (curId && curId !== this.endId) {
          this.endId = curId;
          this.updateSelection(this.startId, this.endId);
        }
      }
    }
    /**
     * 松开鼠标
     * @private
     */

  }, {
    key: "hanldeMouseUp",
    value: function hanldeMouseUp() {
      var disabled = this.props.disabled;

      if (this.isMouseDown === true && !disabled) {
        this.endSelection();
      }
    }
    /**
     * 鼠标over时间格子
     * @param {object} event - 事件event对象
     * @return {void}
     * @private
     */

  }, {
    key: "hanldeMouseOver",
    value: function hanldeMouseOver(event) {
      var disabled = this.props.disabled; // event.persist(); // 有debounce才需要
      //

      if (!disabled) {
        this.updateTip(event);
      }
    }
    /**
     * 离开选区
     * tip显示时，内部移动到tip也算hanldeMouseLeave，快速移动可能触发
     * @private
     */

  }, {
    key: "hanldeMouseLeave",
    value: function hanldeMouseLeave() {
      var disabled = this.props.disabled;
      var curTip = this.state.curTip;

      if (!disabled) {
        if (this.isMouseDown === true) {
          this.endSelection();
        }

        if (curTip) {
          this.setState({
            curTip: ''
          });
        }
      }
    }
    /**
     * 结束选择动作
     * @private
     */

  }, {
    key: "endSelection",
    value: function endSelection() {
      var _this2 = this;

      this.updateSelection(this.startId, this.endId, function () {
        _this2.updateSelectedTimeAndDigit(); // 中间过程使用state，结束之后还是要把选中的数据重新重置用value的值显示


        _this2.setState({
          routineList: _this2.getRoutineList(_this2.props)
        });
      });
      this.originRoutineList = {};
      this.startId = null;
      this.endId = null;
      this.isMouseDown = false;
    }
    /**
     * 更新当前选择的时间界面
     * @param {string} startId - 起始时间id
     * @param {string} endId - 结束时间id
     * @param {func} cb - 更新完state后的回调函数
     * @return {void}
     * @private
     */

  }, {
    key: "updateSelection",
    value: function updateSelection(startId, endId, cb) {
      var _this3 = this;

      if (startId && endId) {
        var week = [startId.slice(0, 1) - 0, endId.slice(0, 1) - 0].sort(function (a, b) {
          return a - b;
        }); // 星期起止

        var time = [startId.slice(1) - 0, endId.slice(1) - 0].sort(function (a, b) {
          return a - b;
        }); // 时间起止
        // 得到需要改值的key的数组

        var selectedList = [];

        for (var i = week[0]; i <= week[1]; i++) {
          for (var j = time[0]; j <= time[1]; j += 50) {
            selectedList.push(i * 10000 + j);
          }
        }

        var routineList = (0, _spauiUtils.objectAssign)({}, this.originRoutineList);
        selectedList.forEach(function (item) {
          if (routineList[item] !== _this3.targetStatus) {
            routineList[item] = _this3.targetStatus;
          }
        });
        this.setState({
          routineList: routineList
        }, function () {
          if (cb) {
            cb();
          }
        });
      }
    }
    /**
     * 根据当前routineList状态得到选择时间段字符串数组、二进制字符串
     * @param {bool} notCallOnChange=false 是否调用onChange函数
     * @private
     */

  }, {
    key: "updateSelectedTimeAndDigit",
    value: function updateSelectedTimeAndDigit() {
      var notCallOnChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var routineList = this.state.routineList;
      var onChange = this.props.onChange;
      var LOCALE = (0, _index.getLocaleData)(this.props.locale);
      var weekDayNames = (0, _index.getWeekDayNames)(LOCALE); // 渲染选中的时间段

      var retObj = {}; // 结果对象

      var isContinue = false;
      var curStart;
      var curEnd;
      this.routineKeys.forEach(function (item, index) {
        var curWeekIndex = item.slice(0, 1) - 1; // 当前星期几的索引

        if (routineList[item] === _index.SELECT_STATUS.SELECTED) {
          // 选中
          var curTime = item.slice(1) - 0;

          if (!isContinue) {
            // 上个已断
            curStart = "0000".concat(curTime - 50).slice(-4); // 若为纯数字可能为0

            curEnd = "0000".concat(curTime).slice(-4);
            isContinue = true;
          } else {
            // 延续上一个
            curEnd = "0000".concat(curTime).slice(-4); // 更新结束时间
          }
        } else {
          // 未选中
          isContinue = false;

          if (curStart && curEnd) {
            // 收集时间
            if (!retObj[curWeekIndex]) {
              retObj[curWeekIndex] = [];
            }

            retObj[curWeekIndex].push([curStart, curEnd]);
            curStart = null;
            curEnd = null;
          }
        }

        if ((index + 1) % 48 === 0) {
          // 一天最后的半小时，当前一天有48个半小时
          if (isContinue) {
            // 最后半小时已选中，收集时间
            if (!retObj[curWeekIndex]) {
              retObj[curWeekIndex] = [];
            }

            retObj[curWeekIndex].push([curStart, curEnd]);
            curStart = null;
            curEnd = null;
            isContinue = false; // 强制结束
          }
        }
      });
      var showArr = [];

      for (var i in retObj) {
        if (retObj[i] && retObj[i].length > 0) {
          var timeArr = retObj[i].map(function (item) {
            return "".concat((0, _index2.timeTranslate)(item[0]), "-").concat((0, _index2.timeTranslate)(item[1]));
          });
          var weekShow = weekDayNames[i] ? weekDayNames[i] : '';
          var tipShow = "".concat(weekShow, ":").concat(timeArr.join(','));
          showArr.push(tipShow);
        }
      } // 得到二进制字符串


      var digitsArr = [];

      for (var _i in routineList) {
        // 考虑兼容性隐患，暂时不用Object.values()
        if (typeof routineList[_i] !== 'undefined') {
          digitsArr.push(routineList[_i]);
        }
      }

      var digitsStr = digitsArr.join('');

      if ((0, _spauiUtils.isFunction)(onChange) && !notCallOnChange) {
        onChange(digitsStr, showArr);
      }
    }
    /**
     * 更新tip内容，确定tip显示位置
     * @param {object} event - 事件event对象
     * @return {void}
     * @private
     */

  }, {
    key: "updateTip",
    value: function updateTip(event) {
      var LOCALE = (0, _index.getLocaleData)(this.props.locale);
      var weekDayNames = (0, _index.getWeekDayNames)(LOCALE);
      var curId = event.target.getAttribute('data-id');
      var offsetLeft = event.target.offsetLeft;
      var offsetTop = event.target.offsetTop;
      var divideWeekKey = 5;
      var divedeTime = 1800;
      var boxSize = {
        width: 13,
        height: 35
      };

      if (curId) {
        var weekKey = curId.slice(0, 1) - 1;
        var time = curId.slice(1) - 0;
        var startTime = (0, _index2.timeTranslate)((10000 + time - 50).toString().slice(-4));
        var endTime = (0, _index2.timeTranslate)((10000 + time).toString().slice(-4));
        var weekShow = weekDayNames[weekKey] ? "".concat(weekDayNames[weekKey], " ") : '';
        var curTip = "".concat(weekShow + startTime, "-").concat(endTime);
        var left;
        var top; // 确定tip显示位置(右下/左下/右上/左上)

        if (weekKey <= divideWeekKey && time <= divedeTime) {
          left = offsetLeft + boxSize.width;
          top = offsetTop + boxSize.height;
        } else if (weekKey <= divideWeekKey && time > divedeTime) {
          left = offsetLeft - 12 * boxSize.width;
          top = offsetTop + boxSize.height;
        } else if (weekKey > divideWeekKey && time <= divedeTime) {
          left = offsetLeft + boxSize.width;
          top = offsetTop - boxSize.height;
        } else {
          left = offsetLeft - 12 * boxSize.width;
          top = offsetTop - boxSize.height;
        }

        this.setState({
          curTip: curTip,
          tipPos: {
            left: left,
            top: top
          }
        });
      }
    }
    /**
     * 清空已选时间
     * @private
     */

  }, {
    key: "clearSelect",
    value: function clearSelect() {
      var stateRoutineList = this.state.routineList;
      var routineList = (0, _spauiUtils.objectAssign)({}, stateRoutineList);
      this.routineKeys.forEach(function (item) {
        routineList[item] = _index.SELECT_STATUS.UNSELECTED;
      });
      this.setState({
        routineList: routineList
      }, this.updateSelectedTimeAndDigit);
    }
    /**
     * 临时占位模版
     * @private
     * @return {Object} 返回模版
     */

  }, {
    key: "getTempTemplate",
    value: function getTempTemplate() {
      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {}, TimeRoutineSelector, this.props));
    }
  }, {
    key: "render",
    value: function render() {
      var LOCALE = (0, _index.getLocaleData)(this.props.locale);
      var weekDayNames = (0, _index.getWeekDayNames)(LOCALE);
      var disabled = this.props.disabled;
      var _this$state = this.state,
          curTip = _this$state.curTip,
          tipPos = _this$state.tipPos,
          routineList = _this$state.routineList;
      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
        className: 'spa-ui'
      }, TimeRoutineSelector), _react["default"].createElement("div", {
        className: "duration"
      }, _react["default"].createElement("ul", {
        className: "header"
      }, _react["default"].createElement("li", {
        className: "pull-left info"
      }, ' ', LOCALE.week, '\\', LOCALE.time, ' '), _react["default"].createElement("li", {
        className: "pull-left time"
      }, _react["default"].createElement("div", {
        className: "num"
      }, "00:00 - 12:00"), _react["default"].createElement("ul", {
        className: "detail clearfix"
      }, _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "0"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "1"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "2"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "3"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "4"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "5"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "6"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "7"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "8"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "9"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "10"), _react["default"].createElement("li", {
        className: "digital pull-left last"
      }, "11"))), _react["default"].createElement("li", {
        className: "pull-left time"
      }, _react["default"].createElement("div", {
        className: "num"
      }, "12:00 - 24:00"), _react["default"].createElement("ul", {
        className: "detail clearfix"
      }, _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "12"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "13"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "14"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "15"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "16"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "17"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "18"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "19"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "20"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "21"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "22"), _react["default"].createElement("li", {
        className: "digital pull-left last"
      }, "23")))), _react["default"].createElement("div", {
        className: "content"
      }, this.isMouseDown === false && curTip ? _react["default"].createElement("div", {
        className: "timetip",
        style: tipPos
      }, _react["default"].createElement("p", null, curTip)) : '', _react["default"].createElement("ul", {
        className: "pull-left week"
      }, weekDayNames.map(function (item, key) {
        return _react["default"].createElement("li", {
          className: "day",
          key: "week_".concat(key)
        }, item);
      })), _react["default"].createElement("ul", {
        className: "boxzone",
        onMouseDown: this.hanldeMouseDown,
        onMouseMove: this.hanldeMouseMove,
        onMouseUp: this.hanldeMouseUp,
        onMouseOver: this.hanldeMouseOver,
        onMouseLeave: this.hanldeMouseLeave
      }, this.routineKeys.map(function (item) {
        return _react["default"].createElement("li", {
          className: "box ".concat(routineList[item] === _index.SELECT_STATUS.SELECTED ? 'active' : ''),
          "data-id": item,
          key: item
        });
      })))), _react["default"].createElement("div", {
        className: "duration-tipline"
      }, _react["default"].createElement("span", {
        className: "color-box color-blue"
      }), _react["default"].createElement("span", null, LOCALE.selected), _react["default"].createElement("span", {
        className: "color-box"
      }), _react["default"].createElement("span", null, LOCALE.unselected), _react["default"].createElement("span", {
        className: "weektip"
      }, LOCALE.operationTip), disabled ? null : _react["default"].createElement("a", {
        style: {
          cursor: 'pointer'
        },
        className: "emptied",
        onClick: this.clearSelect
      }, LOCALE.empty)));
    }
  }]);

  return TimeRoutineSelector;
}(_react.PureComponent); // 组件标记


_defineProperty(TimeRoutineSelector, "propTypes", {
  value: _spauiUtils.PropTypes.string.isRequired,
  disabled: _spauiUtils.PropTypes.bool,
  onChange: _spauiUtils.PropTypes.func.isRequired,
  locale: _spauiUtils.PropTypes.object
});

_defineProperty(TimeRoutineSelector, "defaultProps", {
  value: '',
  disabled: false,
  locale: {}
});

(0, _spauiUtils.setComponentMark)(TimeRoutineSelector, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = TimeRoutineSelector;
exports["default"] = _default;